import { configureStore } from "@reduxjs/toolkit";

import { persistCombineReducers } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { authenticationSlice } from "./authenticationReducer";
import { authorizationSlice } from "./authorizationReducer";
import { personSlice } from "./personReducer";
import { urlSlice } from "./urlReducer";
import { workScheduleSlice } from "./workScheduleReducer";
import { personStaticSlice } from "./personStaticReducer";
import {cutOffDateSlice} from "./cutOffDateReducer";
import { ODSFutureSlice } from "./ODSFutureReducer";
import {selectedLanguageSlice} from "./selectedLanguageReducer";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  
};
//blacklist:['url']
const persistedReducer = persistCombineReducers(persistConfig, {
  authenticate: authenticationSlice.reducer,
  authorize: authorizationSlice.reducer,
  person: personSlice.reducer,
  url:urlSlice.reducer,
  workSchedule: workScheduleSlice.reducer,
  personStatic: personStaticSlice.reducer,
  cutOffDate: cutOffDateSlice.reducer,
  odsfuture: ODSFutureSlice.reducer,
  selectedLanguage:selectedLanguageSlice.reducer
});

const store = configureStore({
  reducer: persistedReducer,
});

export const authenticationActions = authenticationSlice.actions;
export const authorizationActions = authorizationSlice.actions;
export const personActions = personSlice.actions;
export const urlActions = urlSlice.actions;
export const workScheduleActions = workScheduleSlice.actions;
export const personStaticActions = personStaticSlice.actions;
export const cutOffDateActions = cutOffDateSlice.actions;
export const ODSFutureActions = ODSFutureSlice.actions;
export const selectedLanguageActions = selectedLanguageSlice.actions;
export default store;
